import {Slider} from './App/Components/Slider.js';

document.addEventListener('DOMContentLoaded', () => {
    const slider = new Slider();
    slider.init();
});